"use client"

import * as React from "react";
import LastUpdateBadge from "./last-update-badge";
import ProductsContainer from "./products-container";
import {SwrConfig} from "@/lib/swr-config";
import ProductFiltersColumn from "./products-filters-column";
import Container from "@mui/material/Container";
import {Grid} from "@mui/material";
import {apiEndpoints} from "@/utils/api-endpoints";
import {ProductsViewProps} from "@/types/product";
import {useAppSelector} from "@/redux/hooks";


export default function ProductsView({products, queryString, updateDateTime, fullParams}: ProductsViewProps) {
    const user = useAppSelector((state) => state.user.currentUser);

    const fallbackData = {
        [`${apiEndpoints.Product.GetUpdateDateTime.url}`]: updateDateTime,
        [`${apiEndpoints.Product.GetProducts.url(queryString)}`]: products,
    };

    return (
        <Container
            maxWidth = "xl"
            sx = {{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                minHeight: "100dvh",
                pt: 6,
                pb: 10,
            }}
        >
            <SwrConfig value = {{fallback: fallbackData}} >

                <Grid container spacing = {3} mt = {0} pt = "0 !important" sx = {{flex: 1}} >
                    <Grid
                        position = "relative"
                        pt = "0 !important"
                        item
                        lg = {3}
                        xs = {12}
                        sx = {{
                            display: {xs: "none", lg: "block"},
                            position: "relative"
                        }}
                    >
                        <ProductFiltersColumn />
                    </Grid >

                    <Grid
                        item
                        xs = {12}
                        lg = {9}
                        pt = "0 !important"
                        sx = {{display: "flex", flexDirection: "column", minWidth: 0}}
                    >
                        {
                            user && <LastUpdateBadge initialLastUpdate = {updateDateTime ?? null} />
                        }
                        <ProductsContainer
                            initialData = {products}
                            initialParams = {fullParams}
                            initialQueryString = {queryString}
                        />
                    </Grid >
                </Grid >
            </SwrConfig >
        </Container >
    );
}
